<template>
  <div>
    <v-card flat>
      <v-card-title class="headline">
        Coming Soon!
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({

  }),
  created() {
    this.initialize()
  },

  methods: {
    initialize() {}
  }
}
</script>
